<template>
  <div class="header" :class="{[`bg-${type}`]: type}">
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'primary',
        description: 'Header background type'
      }
    }
  }
</script>
<style scoped>
.header {
  background: var(--header-bg) !important;
  color: var(--header-text) !important;
}

.header .container-fluid {
  padding-top: 0.25rem;
}

.header :deep(.text-white) {
  color: #ffffff !important;
}
</style>
